var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"24","height":"24","stroke":_vm.solid ? null : 'currentColor',"fill":_vm.fill}},[_c('use',{attrs:{"href":_vm.href,"xlink:href":_vm.href}})])
}
var staticRenderFns = []

export { render, staticRenderFns }